// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-projets-tsx": () => import("./../../../src/pages/projets.tsx" /* webpackChunkName: "component---src-pages-projets-tsx" */),
  "component---src-pages-qui-est-georges-tsx": () => import("./../../../src/pages/qui-est-georges.tsx" /* webpackChunkName: "component---src-pages-qui-est-georges-tsx" */),
  "component---src-pages-recherches-tsx": () => import("./../../../src/pages/recherches.tsx" /* webpackChunkName: "component---src-pages-recherches-tsx" */)
}

